const collator = new Intl.Collator();

function sortBy(key: string, cb: (a?: any, b?: any) => number) {
  if (!cb) cb = () => 0;
  return (a?: any, b?: any) =>
    typeof a[key] === 'string' && typeof b[key] === 'string'
      ? collator.compare(a[key], b[key]) || cb(a, b)
      : a[key] === null && b[key] !== null
        ? 1
        : b[key] === null && a[key] !== null
          ? -1
          : a[key] > b[key]
            ? 1
            : b[key] > a[key]
              ? -1
              : cb(a, b);
}

function sortByDesc(key: string, cb: (a?: any, b?: any) => number) {
  if (!cb) cb = () => 0;
  return (b?: any, a?: any) =>
    typeof a[key] === 'string' && typeof b[key] === 'string'
      ? collator.compare(a[key], b[key]) || cb(b, a)
      : a[key] === null && b[key] !== null
        ? 1
        : b[key] === null && a[key] !== null
          ? -1
          : a[key] > b[key]
            ? 1
            : b[key] > a[key]
              ? -1
              : cb(b, a);
}

export default function orderBy(
  keys: string[],
  orders: Array<'asc' | 'desc'>
): () => number {
  let cb = () => 0;
  keys.reverse();
  orders.reverse();
  for (const [i, key] of keys.entries()) {
    const order = orders[i];

    if (order === 'asc') {
      cb = sortBy(key, cb);
    } else if (order === 'desc') {
      cb = sortByDesc(key, cb);
    }
  }
  return cb;
}
